module.exports = __webpack_public_path__ + "img/17872_S.aace629b.png";